import 'svelte/internal/disclose-version';
import * as $ from 'svelte/internal/client';
import { markerStore } from "@/stores/markers.svelte";
import { toGlobalCoords } from "@/helpers";

var root = $.from_html(`<div class="marker-actions svelte-1l2zj3puw84nt"><button class="action-btn svelte-1l2zj3puw84nt"><span class="btn-icon svelte-1l2zj3puw84nt">⎘</span> </button> <label class="section-label svelte-1l2zj3puw84nt">RuneLite</label> <div class="button-row svelte-1l2zj3puw84nt"><button class="action-btn svelte-1l2zj3puw84nt"><span class="btn-icon svelte-1l2zj3puw84nt">↓</span> Import</button> <button class="action-btn svelte-1l2zj3puw84nt"><span class="btn-icon svelte-1l2zj3puw84nt">↑</span> Export</button></div> <button class="action-btn danger svelte-1l2zj3puw84nt">Clear All Markers</button></div>`);

function MarkerActions($$anchor, $$props) {
	$.push($$props, true);

	let shareStatus = $.state("");

	async function handleShare() {
		const current = new URL(window.location.href);
		let toCopy = current.href;

		// Skip the API call if we've already shortened the current marker set
		// (indicated by the presence of an `?s=<id>` param; any marker edit
		// clears it via markerStore.syncToUrl).
		if (!current.searchParams.has("s")) {
			$.set(shareStatus, "Shortening…");

			try {
				const res = await fetch("/api/shorten", {
					method: "POST",
					headers: { "content-type": "application/json" },
					body: JSON.stringify({ url: current.href })
				});

				if (res.ok) {
					const data = await res.json();

					if (data?.id) {
						current.searchParams.delete("markers");
						current.searchParams.set("s", data.id);
						history.replaceState(null, "", current);
						toCopy = current.href;
					}
				}
			} catch {
				// Network / endpoint unreachable — fall through to copying the full URL.
			}
		}

		try {
			await navigator.clipboard.writeText(toCopy);
			$.set(shareStatus, "Copied!");
			setTimeout(() => $.set(shareStatus, ""), 1500);
		} catch {
			$.set(shareStatus, "");
			prompt("Copy this URL:", toCopy);
		}
	}

	function handleImport() {
		const input = prompt("Paste RuneLite Ground Markers JSON:");

		if (!input) return;

		try {
			const data = JSON.parse(input);

			if (!Array.isArray(data)) {
				alert("Invalid format: expected a JSON array");

				return;
			}

			let count = 0;

			for (const marker of data) {
				if (marker.regionId == null || marker.regionX == null || marker.regionY == null) continue;

				const plane = marker.z || 0;
				const coords = toGlobalCoords(marker.regionId, marker.regionX, marker.regionY);

				if (markerStore.has(plane, coords.globalX, coords.globalY)) continue;

				let color = "#FFFF0000";

				if (typeof marker.color === "string") {
					color = marker.color;
				} else if (marker.color?.value != null) {
					const intColor = marker.color.value >>> 0;

					color = "#" + intColor.toString(16).padStart(8, "0").toUpperCase();
				}

				markerStore._rawPlace(plane, coords.globalX, coords.globalY, color, marker.label);
				markerStore.onPlace?.(plane, coords.globalX, coords.globalY, color);
				count++;
			}

			alert(`Imported ${count} marker(s)`);
		} catch(e) {
			alert("Failed to parse JSON: " + e.message);
		}
	}

	function handleExport() {
		if (markerStore.count === 0) {
			alert("No markers to export");

			return;
		}

		const data = markerStore.markers.map((m) => {
			const entry = {
				regionId: m.regionId,
				regionX: m.regionX,
				regionY: m.regionY,
				z: m.z,
				color: m.color
			};

			if (m.label) entry.label = m.label;

			return entry;
		});

		const json = JSON.stringify(data);

		navigator.clipboard.writeText(json).then(() => alert(`Exported ${data.length} marker(s) to clipboard`), () => prompt("Copy this JSON:", json));
	}

	function handleClear() {
		if (markerStore.count === 0) return;
		if (!confirm(`Remove all ${markerStore.count} markers?`)) return;

		markerStore.clearAll();
	}

	var div = root();
	var button = $.child(div);
	var text = $.sibling($.child(button));

	$.reset(button);

	var div_1 = $.sibling(button, 4);
	var button_1 = $.child(div_1);
	var button_2 = $.sibling(button_1, 2);

	$.reset(div_1);

	var button_3 = $.sibling(div_1, 2);

	$.reset(div);
	$.template_effect(() => $.set_text(text, ` ${($.get(shareStatus) || "Share URL") ?? ''}`));
	$.delegated('click', button, handleShare);
	$.delegated('click', button_1, handleImport);
	$.delegated('click', button_2, handleExport);
	$.delegated('click', button_3, handleClear);
	$.append($$anchor, div);
	$.pop();
}

if (import.meta.hot) {
	MarkerActions = $.hmr(MarkerActions);

	import.meta.hot.accept((module) => {
		$.cleanup_styles('svelte-1l2zj3puw84nt');
		MarkerActions[$.HMR].update(module.default);
	});
}

export default MarkerActions;

$.delegate(['click']);
import "bun-svelte:MarkerActions.svelte-39my84bvqqwk6-style.css";